var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "비밀번호 확인"
  }, [_c('v-password-confirm-field', {
    attrs: {
      "password": _vm.inputs.password,
      "outlined": ""
    }
  })], 1), _c('template', {
    slot: "연락처"
  }, [_c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "phone", $$v);
      },
      expression: "inputs.phone"
    }
  })], 1), _c('template', {
    slot: "주소"
  }, [_c('v-address-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'grey-6 white--text',
        className: 'w-80px w-lg-100px mt-n8'
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  })], 1)], 2), _c('terms-of-agreements-short', {
    on: {
      "isValid": function (_isValid) {
        function isValid(_x) {
          return _isValid.apply(this, arguments);
        }
        isValid.toString = function () {
          return _isValid.toString();
        };
        return isValid;
      }(function (isValid) {
        return _vm.isTermsValid = isValid;
      }),
      "input": _vm.emit
    },
    model: {
      value: _vm.inputs._terms,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "_terms", $$v);
      },
      expression: "inputs._terms"
    }
  }), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "disabled": !_vm.isValid,
      "color": "primary"
    },
    on: {
      "click": _vm.join
    }
  }, [_c('span', [_vm._v("가입하기")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }